import React from "react";
import Emp_Files_Page from "./Emp_Files_Page";

// Thin wrapper — page rendering is identical to Emp_Healthcard_Files, only
// the `kind` prop differs so the shared component talks to the form16
// backend table + folder.
export default function Emp_Form16_Files({ navSize }) {
    return <Emp_Files_Page navSize={navSize} kind="form16" />;
}
